import $ from "jquery";
import "jquery-mask-plugin/src/jquery.mask.js";
import "bootstrap/js/src/collapse.js";
import "./util/jquery.countdown";
import cssHasPseudo from "css-has-pseudo/browser";
import initializeCollapsibleListeners from "./components/collapsibleItems";
import initializeAnnouncementBar from "./components/header/announcementBar";
import initializeTooltipItems from "./components/tooltip";
import initSwiperCarousels from "./components/swiperCarousel";
import initializeOverlay from "./components/overlay";
import initImagesComponents from "./components/images";
import initializePlanConflictListeners from "./components/planConflict";
import initializeTrackingConsent from "./components/trackingConsent";
import gtm from "../js/gtm";
import constants from "./constants";


window.jQuery = $;
window.$      = $;

$(() => {
    initializeCollapsibleListeners();
    initializeTooltipItems();
    initSwiperCarousels();
    initializeOverlay();
    initImagesComponents();
    initializeAnnouncementBar();
    initializePlanConflictListeners();
    initializeTrackingConsent();
    cssHasPseudo(document);

    if (window.dataLayer) {
        gtm.pageViewEvent();

        if ($(".error-page").length) {
            gtm.trackError();
        }

        $(".call-me__options__list a").first().on("click", function () {
            gtm.trackFormSubmit(constants.GTM.EVENTS.WHATSAPP_LINK);
        });

        $(".gtm-banner").on("click", function () {
            if ($(this).hasClass("js-promo-banner")) {
                gtm.trackSelectPromotion(undefined);
            }
        });
    }
});

require('./components/spinner');
require('./thirdParty/bootstrap');